namespace Matrix.Rebalancer {
    export interface InstructionTaskMapRow {
        MapId?: number;
        InstructionFilterScript?: string;
        TaskTypeCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        TaskTypeName?: string;
        TaskTypeRowId?: number;
    }

    export namespace InstructionTaskMapRow {
        export const idProperty = 'MapId';
        export const nameProperty = 'InstructionFilterScript';
        export const localTextPrefix = 'Rebalancer.InstructionTaskMap';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            MapId = "MapId",
            InstructionFilterScript = "InstructionFilterScript",
            TaskTypeCode = "TaskTypeCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            TaskTypeName = "TaskTypeName",
            TaskTypeRowId = "TaskTypeRowId"
        }
    }
}
